/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown>, price: NonNullable<unknown> }} Plan_Gate_Upgrade_ButtonInputs */



/**
* | output |
* | --- |
* | "Upgrade to {plan} — €{price}/user/month" |
*
* @param {Plan_Gate_Upgrade_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_upgrade_button = /** @type {((inputs: Plan_Gate_Upgrade_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Upgrade_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Upgrade auf ${i?.plan} — €${i?.price}/Nutzer/Monat`)
	return /** @type {LocalizedString} */ (`Upgrade to ${i?.plan} — €${i?.price}/user/month`)
});